<template>
    <BaseFacets ref="facets" :rawFacetData="matchmakerFacetData" :facetCriteria="passedFacetCriteria" :facetError="facetError" :facetLoader="facetLoader" :sidebarNavigation="false" :omitCount="true" v-on:update-search="updateSearch" v-on:clear-selections="clearSelections"
    v-on:reinit-search="reinitSearch"></BaseFacets>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex';
    import BaseFacets from '@/components/global/BaseFacets.vue';
    // import globalMixins from '@/globalMixins';

    export default {
        name: 'facets',
        components: {
            BaseFacets
        },
        data: function () {
            return {
                // facetData: null,
                defaultFacetCriteria: {
                    is_active_projects: true
                },
                facetError: false,
                facetLoader: false,
                facetCriteriaOrg: {},
                updateProjectSearchResultsTimeout: null
            };
        },
        computed: {
            ...mapGetters([
                'searchMeta',
                'matchmakerFacetCriteria',
                'matchmakerFacetData',
                'matchmakerResults',
                'matchmakerPOResults',
                'searchType'
            ]),
            passedFacetCriteria: function () {
                return Object.assign(this.defaultFacetCriteria, this.matchmakerFacetCriteria);
            }
        },
        mounted () {
            if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
                this.$router.push({ path: '/' }).catch(err => {});
            } else {
                this.facetError = false;
                
                let searchResults = copyData(this.matchmakerResults)
                if (this.$route.name == 'matchmaker-pos') {
                    searchResults = copyData(this.matchmakerPOResults)
                }
                //if (!this.matchmakerFacetData && this.searchResults) {
                if (!this.matchmakerFacetData) {
                    this.facetLoader = true;
                    this.facetCriteriaOrg = {};
                    this.getMatchmakerFacets(false);
                } 
            }
        },
        methods: {
            ...mapActions([
               'setMatchmakerFacetData',
               'setMatchmakerFacetCriteria',
               'updateMatchmakerFacetCriteria',
               'setMatchmakerResults',
               'setMatchmakerPOResults'
            ]),
            getMatchmakerFacets (changeCriteria) {
                if (this.$route.query) {
                    this.$parent.parseFacetFiltersFromURL();
                }

                if (this.$route.name === 'matchmaker-projects' || this.$route.name === 'matchmaker-pos') {
                    this.loadingPubFacets = true;
                    this.$parent.getMatchmakerSearchFacets(changeCriteria, this.loadMatchmakerSearchFacets);
                } else {
                    this.setMatchmakerFacetData(null);
                    this.setMatchmakerFacetCriteria(null);
                }
            },
            loadMatchmakerSearchFacets (data) {
                var self = this,
                    tempFacetIndex,
                    isExists = false,
                    orgData = copyData(data);

                this.facetLoader = false;
                if (!data.status) {
                    data = copyData(data);

                    this.setMatchmakerFacetData(data);
                   
                    if (!this.matchmakerFacetCriteria) {
                        this.setMatchmakerFacetCriteria(data);
                        this.$parent.parseFacetFiltersFromURL();
                    } else {
                        for (let item in this.facetCriteriaOrg) {
                            for (let i = 0; i < orgData.facets.length; i++) {
                                if (orgData.facets[i].name === item) {
                                    tempFacetIndex = i;
                                    break;
                                }
                            }
                            if (tempFacetIndex) {
                                for (let i = 0; i < this.facetCriteriaOrg[item].length; i++) {
                                    isExists = false;
                                    orgData.facets[tempFacetIndex].values.filter((val) => {
                                        if (val && this.facetCriteriaOrg[item][i] && val.value === this.facetCriteriaOrg[item][i].value) {
                                            isExists  = true;
                                            return;
                                        }
                                    });
                                    if (!isExists && this.facetCriteriaOrg[item][i]) {
                                        orgData.facets[tempFacetIndex].values.push({
                                            value: this.facetCriteriaOrg[item][i].value,
                                            display: this.facetCriteriaOrg[item][i].display,
                                            count: 0
                                        });
                                    }
                                }
                            }
                        }
                        data = copyData(orgData);
                        this.setMatchmakerFacetData(data);
                    }
                } else {
                    this.setMatchmakerFacetData(null);
                    this.setMatchmakerFacetCriteria(null);
                    this.facetError = true;
                }

                if (this.matchmakerFacetCriteria && this.matchmakerFacetCriteria['is_active_projects'] === undefined) {
                    this.updateMatchmakerFacetCriteria(this.passedFacetCriteria);
                }
            }, 
            reinitSearch () {
                this.$nextTick(() => {
                    this.$parent.$refs.matchmakerCriteria.search(true);
                });
            },
            updateSearch (newFacetCriteria, timeout) {
                var facetToQueryStr = '';

                if (!timeout) {
                    timeout = 500;
                }

                this.facetError = false;

                if (!newFacetCriteria.program_officials || newFacetCriteria.program_officials.length === 0) {
                    this.$parent.showPOProjects = false;
                }
                this.updateMatchmakerFacetCriteria(newFacetCriteria);

                this.updateProjectSearchResultsTimeout = setTimeout(() => {
                    this.reloadSearch();
                }, timeout);
            },
            clearSelections (newFacetCriteria) {
                if (!newFacetCriteria.program_officials || newFacetCriteria.program_officials.length === 0) {
                    this.$parent.showPOProjects = false;
                }
                this.updateMatchmakerFacetCriteria(newFacetCriteria);

                this.reloadSearch();
            },
            reloadSearch () {
                if (this.$parent.scrollToResultsTop) {
                    this.$parent.scrollToResultsTop();
                }

                this.$parent.clearSearchResults({resetFacets: false});
                this.$parent.isPageLoading = true;
                if (this.$route.name === 'matchmaker-pos') {
                    this.$parent.POListTable.offset = 0;
                    this.$parent.POListTable.isLoading = true;
                    this.setMatchmakerResults(null);
                    this.$parent.getMatchmakerPOResults(false, false);
                } else {
                    this.$parent.matchMakerListTable.offset = 0;
                    this.$parent.matchMakerListTable.isLoading = true;
                    this.setMatchmakerPOResults(null);
                    this.$parent.getMatchmakerSearchResults(false, false);
                }
                this.getMatchmakerFacets(false);
                this.$parent.getMatchmakerProjectsChartData(false);
            },
            resetFacets () {
                this.setMatchmakerFacetData(null);
                this.setMatchmakerFacetCriteria(null);
                this.facetCriteriaOrg = {};
            },
            generateQueryString () {
                return this.$refs.facets.generateQueryString();
            }
        }
  }

</script>

<style lang="scss" scoped>
</style>
